export default __webpack_public_path__ + "static/media/credit-card.a0ca18e3.jpg";